<template>
	<div>
		<div class="popBoxBg ">
			
		</div>
		<div class="keyboard">
			<div class="read-bd-title fc" style="padding-left: 30px;">
				<i></i><h3>{{keyTitle}}</h3>
			</div>
			<div class="input" :class="{grey:!keyInput}">{{keyInput || keyTitle}}
			
			</div>
			<ul v-if="isKeyAbc" class="abc-list">
				<li class="fcc" v-for="item in abc" @click="num(item)">{{item}}</li>
				<li class="fcc" @click="showABC">123</li>
				<li class="fcc clear" @click="tuige">回删</li>
				<li class="fcc clear" @click="clear">清空</li>
			</ul>
			<ul v-else="isKeyAbc">
							<li class="fcc" v-for="item in 9" @click="num(item)">{{item}}</li>
							
							
							<li class="fcc" @click="showABC">ABC</li>
							<li class="fcc" @click="num('0')">0</li>
			
							<li class="fcc clear" @click="clear">清空</li>
			
						</ul>
			<div class="ft">
				<div class="fc-bet">
					<div class="fcc return" @click="close">
						<img src="../../assets/icon/icon-return.png" >
						<span>返回</span>
					</div>
					<div class="fcc enter" @click="enter">
						<img src="../../assets/icon/icon-ok.png" >
						<span>确定</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'q-abc',
		props: {
			keyTitle:{
				type:String,
				default:"请输入门诊号码或请刷门诊号码条形码"
			}
		},
		data() {
			return {
				
				keyInput:"",
				isKeyAbc:false,
				abc:[]
			}
		},
	
		created() {
			var zm='ABCDEFGHIJKLMNOPQRSTUVWXYZ'
			this.abc=zm.split("")
		},
		mounted() {
			
		},
		methods: {
			num(i){
				var that=this
				that.keyInput="" + that.keyInput + i
			
			},
			tuige(){
				var str="" + this.keyInput
				str=str.slice(0,str.length-1)
				this.keyInput=str
			},
			clear(){
				this.keyInput=""
			},
			showABC(){
				this.isKeyAbc=!this.isKeyAbc
			},
			close(){
				this.$emit("key-close",false)
			},
			enter(){
				this.$emit("key-input",this.keyInput)
			}
		},
		watch: {
			
		},
		beforeDestroy() {
			
		}
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less" scoped>
	.keyboard{
		width: 901px;
		
		background-color: #fff;
		position: absolute;
		left: 50%;
		margin-left: -450px;
		bottom: 120px;
		border-radius: 15px;
		z-index: 110;
		
		.input{
			margin-right: 44px;
			height: 95px;
			background: #EFEFEF;
			border-radius: 10px;
			margin-left: 40px;
			margin-bottom: 33px;
			font-size: 30px;
			line-height: 95px;
			padding-left: 30px;
			padding-right: 30px;
			color: #000;font-weight: bold;
			position: relative;
			.tips{
				position: absolute;
				right: 30px;
				top: 0;
				color: red
			}
			&.grey{
				color: #bbb;
			}
		}
		ul{
			display: flex;
			flex-wrap: wrap;
			
			padding-left: 40px;
		}
		li{
			width: 247px;
			height: 95px;
			background: #fff;
			border: 1px solid #DADADA;
			border-radius: 10px;
			font-size: 30px;
			color: #000;
			margin-right: 35px;
			margin-bottom: 33px;
			cursor: pointer;
			&:active{
				background: #00A2FF;
				color: #fff;
			}
		}
		.abc-list{
				li{
					width: 119px;
					margin-right: 18px;
					margin-bottom: 25px;
				}
				.clear{
					width: 188px;
				}
		}
		.tuige{
			background: url(../../assets/icon/icon-tuige.png) center no-repeat;
			&:active{
				background: url(../../assets/icon/icon-tuige2.png) center no-repeat #00A2FF;
				color: #fff;
			}
		}
		
	}
	
	.ft{
		margin-left: 40px;margin-right: 44px;
		padding-bottom: 47px;
		.return{
			background: #38BB8B;
			color: #fff;
			width: 247px;
			height: 95px;cursor: pointer;
			font-size: 30px;
			color: #fff;
			border-radius: 10px;
			img{
				margin-right: 14px;
			}
		}
		.enter{
			background: #00A2FF;
			color: #fff;
			width: 247px;cursor: pointer;
			height: 95px;font-size: 30px;
			color: #fff;border-radius: 10px;
			img{
				margin-right: 14px;
			}
		}
	}
</style>
